import { any } from 'prop-types';

export const formTypes = {
  registeredFields: any.isRequired,
  syncErrors: any,
  values: any
};
